export {
    default as areAnyTXPEntitiesSupported,
} from './utils/featureChecks/areAnyTXPEntitiesSupported';
